/**
 * Need a class that can convert things between day-of-year and time
 */

import { addForegroundedEvent } from "@utils/underhood/app-state-change"
import {
    addDays,
    addMinutes,
    differenceInCalendarDays,
    differenceInDays,
    format,
    startOfYear,
} from "date-fns"
import { type Readable, readable, writable } from "svelte/store"

export type MinutesAfterMidnight = number
export type DaysSinceBeginning = number

export class Day {
    /**
     *
     * @param daySinceBeginning
     */
    constructor(public readonly daySinceBeginning: DaysSinceBeginning) {}

    static fromToday(): Day {
        return this.fromDay(new Date())
    }

    static fromDay(date: Date): Day {
        // Note in the future there may be time travellers using this app
        // so it's good to go back as far as we can

        const arbitraryStartDate = new Date(1971, 0, 1)
        const daysSinceBeginning = differenceInCalendarDays(date, arbitraryStartDate)
        return new Day(daysSinceBeginning)
    }

    // static fromDayNumberThisYear(dayOfYear: number): Day {
    //     //Fix this
    //     const startOfThisYear = startOfYear(new Date())
    //     const dateFromDayNumber = addDays(startOfThisYear, dayOfYear - 1) // -1 because dayOfYear starts from 1
    //     const start = addMinutes(new Date(1970, 0, 1), minutesOffsetFromMidnight) // Start of 1970
    //     const daysSinceBeginning = differenceInDays(dateFromDayNumber, start)
    //     return new Day(daysSinceBeginning)
    // }

    add(delta: number) {
        // const startDate = new Date(1970, 0, 1) // Start of 1970
        // const targetDate = addDays(startDate, this.daySinceBeginning + delta)
        // const daysSinceBeginning = differenceInDays(targetDate, startDate)
        return new Day(delta + this.daySinceBeginning)
    }

    nextDay(): Day {
        return this.add(1)
    }

    previousDay(): Day {
        return this.add(-1)
    }

    isBefore(other: Day): boolean {
        return this.daySinceBeginning < other.daySinceBeginning
    }

    isAfter(other: Day): boolean {
        return this.daySinceBeginning > other.daySinceBeginning
    }

    isEqual(other: Day): boolean {
        return this.daySinceBeginning === other.daySinceBeginning
    }

    /**
     * If {@link other} is greater than this, returns a positive number.
     * @param other
     * @returns
     */
    differenceBetween(other: Day) {
        return other.daySinceBeginning - this.daySinceBeginning
    }

    getDate(): Date {
        const startDate = new Date(1970, 0, 1) // Start of 1970
        return addDays(startDate, this.daySinceBeginning)
    }

    format(formatString: string): string {
        const currentDate = this.getDate()
        return format(currentDate, formatString)
    }
}

/**
 * Just a store that always has the current day
 */
export const dayToday = readable(Day.fromToday(), (set) => {
    const update = () => set(Day.fromToday())
    const interval = setInterval(update, 1000 * 60)
    return () => clearInterval(interval)
})

const currentDateWritable = writable(new Date())
const updateDate = () => currentDateWritable.set(new Date())

/**
 * Just a store that always has the current day
 */
export const currentDate: Readable<Date> = { subscribe: currentDateWritable.subscribe }
setInterval(updateDate, 1000 * 60)

/**
 * Update date when coming into foreground
 */
addForegroundedEvent(updateDate)
